/**
 * Ultimadesk : pastilles en bas de l'image des cartes produit (snippet ultimadesk-card-swatches).
 * Au survol d'une pastille (ou au focus clavier), l'image de cette couleur se pose sur la photo de
 * la carte ; elle disparaît quand la souris quitte les pastilles. Les images des couleurs sont
 * préchargées au premier survol de la carte, pour que l'aperçu soit immédiat.
 */

class UdCardSwatches extends HTMLElement {
  connectedCallback() {
    this.gallery = this.closest('product-card-media-gallery');
    this.card = this.closest('product-card');
    if (this.gallery == null) return;

    this.onOver = (event) => this.show(event.target.closest('.ud-card-swatch'));
    this.onLeave = () => this.hide();
    this.onFocusIn = (event) => this.show(event.target.closest('.ud-card-swatch'));
    this.onFocusOut = (event) => {
      if (!this.contains(event.relatedTarget)) this.hide();
    };
    this.onCardEnter = () => this.preload();

    this.addEventListener('pointerover', this.onOver);
    this.addEventListener('pointerleave', this.onLeave);
    this.addEventListener('focusin', this.onFocusIn);
    this.addEventListener('focusout', this.onFocusOut);
    this.card?.addEventListener('pointerenter', this.onCardEnter, { once: true });
  }

  disconnectedCallback() {
    this.removeEventListener('pointerover', this.onOver);
    this.removeEventListener('pointerleave', this.onLeave);
    this.removeEventListener('focusin', this.onFocusIn);
    this.removeEventListener('focusout', this.onFocusOut);
    this.card?.removeEventListener('pointerenter', this.onCardEnter);
  }

  get sizes() {
    return this.gallery.querySelector('img')?.getAttribute('sizes') || '(min-width: 750px) 25vw, 50vw';
  }

  preload() {
    this.querySelectorAll('.ud-card-swatch[data-image]').forEach((swatch) => {
      const image = new Image();
      image.sizes = this.sizes;
      image.srcset = swatch.dataset.srcset || '';
      image.src = swatch.dataset.image;
    });
  }

  show(swatch) {
    if (swatch?.dataset.image == null) {
      this.hide();
      return;
    }

    if (this.preview == null) {
      this.preview = document.createElement('img');
      this.preview.className = 'ud-card-swatch-preview';
      this.preview.alt = '';
      this.preview.decoding = 'async';
      this.preview.sizes = this.sizes;
      this.gallery.prepend(this.preview);
    }

    this.preview.srcset = swatch.dataset.srcset || '';
    this.preview.src = swatch.dataset.image;
    this.preview.hidden = false;
  }

  hide() {
    if (this.preview) this.preview.hidden = true;
  }
}

if (!customElements.get('ud-card-swatches')) customElements.define('ud-card-swatches', UdCardSwatches);
